import axios from 'axios'
import { baseURL } from '@/services/baseURL.js'
import Store from '@/store';

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    accept: 'application/json',
    'content-type': 'application/json',
  },
  withCredentials: false,
})




export default {
  getSenaraiServClass() {
    return apiClient.post('/selenggara/get_ServClassList.php')
  },
  getSenaraiSchmOfServ(ServClassId) {
    return apiClient.get('/selenggara/get_SchmOfServList.php', { params: ServClassId })
  },
  getSenaraiSalGrd(search) {
    return apiClient.get('/selenggara/get_SalGrdList.php', { params: search })
  },
  getSalGrd(search) {
    return apiClient.get('/selenggara/getDetailSalgred.php', { params: search })
  },
  getServClass(search) {
    return apiClient.get('/selenggara/getDetailServClass.php', { params: search })
  },
  getSchmOfServ(search) {
    return apiClient.get('/selenggara/getDetailSchmOfServ.php', { params: search })
  },
  getTahun() {
    //return apiClient.get('/selenggara/get_tahun.php', { params: search })
    return apiClient.get('/selenggara/get_tahun.php')
  },

  getTPG(search) {
    return apiClient.get('/selenggara/get_TPG.php', { params: search })
  },






}
